import React from "react";
import { FileText } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";
import { isNarrativeAssessmentLine } from "./narrativeAssessmentLineUtils";

const NarrativeAssessmentLineViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={FileText}
    subtitle="Foundational assessment interpretation"
    badge="FOUNDATION"
    theme={{
      cardBg: "#f8fafc",
      cardBorder: "#e2e8f0",
      heroBg: "#eef2ff",
      heroBorder: "#cbd5e1",
      badgeBg: "rgba(99, 102, 241, 0.12)",
      badgeBorder: "#6366f1",
      iconColor: "#4338ca",
      dotColor: "#6366f1",
    }}
  />
);

export { isNarrativeAssessmentLine };
export default NarrativeAssessmentLineViewer;
